<template>
  <div class="w-full">
    <div class="w-[90%] max-w-xl mx-auto">
      <div class="w-full pt-14">
        <!-- <img src="@/assets/svgs/logo.svg" alt="" /> -->
      </div>
      <div class="w-full mt-10">
        <div
          v-if="loading"
          class="w-full pt-40 flex items-center justify-center"
        >
          <spinner />
        </div>
        <div class="w-full" v-else>
          <div class="w-full">
            <div class="w-full flex items-center justify-between">
              <span
                >Total Stations:
                <span class="font-bold">{{ total }}</span></span
              >
              <button
                @click="inviteModal = true"
                class="bg-realBlack text-white font-medium py-2 px-6 rounded-lg cursor-pointer"
              >
                Create Charge Station
              </button>
              <CreateStation v-if="inviteModal" :closeModal="closeInvite" />
            </div>
            <table class="w-full text-left mt-8">
              <tr>
                <th class="pl-2 py-2 text-center"></th>
                <th>Name</th>
                <th>Address</th>
                <th>Lat</th>
                <th>Long</th>
                <th>Chargers</th>
                <th class="pr-2">Open Hours</th>
              </tr>
              <tr
                :class="[
                  'border-b border-b-grey border-opacity-20 cursor-pointer hover:bg-grey hover:bg-opacity-45 transition-all',
                  (index + 1) % 2
                    ? 'bg-grey bg-opacity-20'
                    : 'bg-grey bg-opacity-5',
                ]"
                v-for="(station, index) in stations"
                :key="station.id"
              >
                <td class="pl-2 py-2 text-center">
                  <div class="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      :src="station.img_url"
                      alt=""
                      class="w-full object-contain"
                    />
                  </div>
                </td>
                <td>{{ station.name }}</td>
                <td>{{ station.address }}</td>
                <td class="py-2">{{ station.lat }}</td>
                <td class="py-2">{{ station.lon }}</td>
                <td class="py-2">
                  {{
                    station.chargers.reduce(
                      (sum, charger) => sum + charger.count,
                      0
                    )
                  }}
                </td>
                <td class="pr-2 py-2">
                  {{ station.open_hours }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";
import CreateStation from "@/components/CreateStation.vue";
export default {
  name: "HomeView",
  data() {
    return {
      stations: [],
      singleOrder: {},
      loading: true,
      adding: false,
      total: 0,
      singleActive: false,
      inviteModal: false,
    };
  },

  components: { Spinner, CreateStation },
  methods: {
    closeInvite() {
      this.inviteModal = false;
      this.getStations();
    },

    closeSingleOrder(e) {
      this.singleOrder = {};
      this.singleActive = false;
    },
    async getStations(filters = "") {
      // this.loading = true;
      var payload = { path: "/charge-stations" };
      const response = await this.$store.dispatch("getRequest", payload);
      this.stations = response.data.data;
      // this.filterOptions = response.data.data.filter_options;
      this.total = response.data.data.length;
      this.loading = false;
    },
  },
  async mounted() {
    await this.getStations();
    // window.addEventListener("popstate", (event) => {
    //   event.preventDefault();
    //   history.pushState(null, null, window.location.href);
    //   console.log(event);
    // });
  },
};
</script>


<style scoped>
td {
  font-size: 0.8rem;
}

td,
th {
  padding-right: 12px;
}
</style>